import * as Zod from 'zod';

export const peopleSearchValidation = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
